module.exports = __webpack_public_path__ + "static/media/Icon_white_500px.5da627f5.png";